/**
 * The boxes a row's score cluster is built from (completion-dots.tsx), as class strings. A LEAF module for
 * the same reason as `strip-metrics`: the pending UIs draw this cluster and live in the entry bundle, so
 * importing it from `completion-dots.tsx` would drag lingui and the indicator palette in with them.
 */

/**
 * One score column: a fixed TRACK carrying no ink, so a `100%` badge can never widen its own column and pull
 * the rows out of line with each other. 2.5rem is what its widest tenant needs in Plus Jakarta Sans Bold —
 * `100%` measures 39.5px.
 */
export const SCORE_COLUMN_CLASS = 'flex w-10 items-center justify-center'
/** The tinted box inside the track, sized to its own content, the track supplying the rest. */
export const SCORE_FILL_CLASS = 'inline-flex max-w-full items-center justify-center px-1'
/** The cluster's own box. */
export const SCORE_CLUSTER_CLASS = 'inline-flex w-fit items-center'
/** The global summary reads as a total, not a fourth ámbito, so it sits apart. */
export const SCORE_GLOBAL_CLASS = 'ml-2'
/**
 * The badge inside a track. `min-h` off its own `1em` keeps the dash state as tall as a numeric one, whose
 * height comes from its text line box — so a skeleton bar carrying these classes IS the badge's box.
 */
export const SCORE_BADGE_BOX = 'min-h-[calc(1em+0.25rem)] rounded-sm py-0.5 text-[11px] leading-none'
